import React, { useEffect, useRef, useState } from 'react'
import Layout from '../Components/Layouts/Layout'
import { getImages } from '../Components/Const';
import AnnouncementsForm from '../Components/EditAnnouncements/AnnouncementsForm';

const EditAnnouncements = () => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
     useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
  return (
    <>
        <Layout hideTopBar={true}>
            <section className='edit-announcements-wrap'>
                <div className='container'>
                    {/* <div className='d-md-flex align-items-center justify-content-between mb-4'>
                        <div className='md-title text-uppercase font-26 text-lgray'>Edit Announcements</div>
                        <div>
                            <button type='button' className='blue-transparent-btn dark-transparent-btn text-uppercase'>Add Announcement</button>
                        </div>
                    </div>
                    <div className='ea-box mb-4'>
                        <div className='d-md-flex align-items-center justify-content-between mb-2'>
                            <div className='sm-title text-uppercase font-1-1em fw-500'>Announcement 1</div>
                            <div className='d-flex align-items-center'>
                                <div ref={dropdownRef} className="btn-group calender-dropdown custom-dropdown announcement-dropdown me-3 position-relative">
                                    <button onClick={() => setOpen(!open)} className="btn btn-secondary dropdown-toggle text-green mt-1" >
                                        <img src={getImages('options-icons.png')}/>
                                    </button>
                                    <div className={`dropdown-menu dropdown-menu-custom dropdown-menu-end right-0 ${open ? "show" : ''}`}>
                                        <button type='button' className='dropdown-item text-dblue font-bold text-uppercase'>Edit</button>
                                        <button type='button' className='dropdown-item text-red font-bold text-uppercase'>Delete</button>
                                    </div>
                                </div>
                                <div>
                                    <button type='button' className='ea-transparent-btn'><img src={getImages('reorder-material.png')}/></button>
                                </div>
                            </div>
                        </div>
                        <div className='ea-custom-form'>
                            <div className='row align-items-end'>
                                <div className='col-md-10'>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <label>Message</label>
                                        <label>Char 32 /50</label>
                                    </div>
                                    <input type='text' className='form-control'/>
                                </div>
                                <div className='col-md-2'>
                                    <label>Exp Date</label>
                                    <input type='text' className='form-control icon-calendar-field pe-5'/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='ea-box mb-4'>
                        <div className='d-md-flex align-items-center justify-content-between mb-2'>
                            <div className='sm-title text-uppercase font-1-1em fw-500'>Announcement 2</div>
                            <div className='d-flex align-items-center'>
                                <div ref={dropdownRef} className="btn-group calender-dropdown custom-dropdown announcement-dropdown me-3 position-relative">
                                    <button onClick={() => setOpen(!open)} className="btn btn-secondary dropdown-toggle text-green mt-1" >
                                        <img src={getImages('options-icons.png')}/>
                                    </button>
                                    <div className={`dropdown-menu dropdown-menu-custom dropdown-menu-end right-0 ${open ? "show" : ''}`}>
                                        <button type='button' className='dropdown-item text-dblue font-bold text-uppercase'>Edit</button>
                                        <button type='button' className='dropdown-item text-red font-bold text-uppercase'>Delete</button>
                                    </div>
                                </div>
                                <div>
                                    <button type='button' className='ea-transparent-btn'><img src={getImages('reorder-material.png')}/></button>
                                </div>
                            </div>
                        </div>
                        <div className='ea-custom-form'>
                            <div className='row align-items-end'>
                                <div className='col-md-10'>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <label>Message</label>
                                        <label>Char 32 /50</label>
                                    </div>
                                    <input type='text' className='form-control'/>
                                </div>
                                <div className='col-md-2'>
                                    <label>Exp Date</label>
                                    <input type='text' className='form-control icon-calendar-field pe-5'/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='ea-box mb-4'>
                        <div className='d-md-flex align-items-center justify-content-between mb-2'>
                            <div className='sm-title text-uppercase font-1-1em fw-500'>Announcement 3</div>
                            <div className='d-flex align-items-center'>
                                <div ref={dropdownRef} className="btn-group calender-dropdown custom-dropdown announcement-dropdown me-3 position-relative">
                                    <button onClick={() => setOpen(!open)} className="btn btn-secondary dropdown-toggle text-green mt-1" >
                                        <img src={getImages('options-icons.png')}/>
                                    </button>
                                    <div className={`dropdown-menu dropdown-menu-custom dropdown-menu-end right-0 ${open ? "show" : ''}`}>
                                        <button type='button' className='dropdown-item text-dblue font-bold text-uppercase'>Edit</button>
                                        <button type='button' className='dropdown-item text-red font-bold text-uppercase'>Delete</button>
                                    </div>
                                </div>
                                <div>
                                    <button type='button' className='ea-transparent-btn'><img src={getImages('reorder-material.png')}/></button>
                                </div>
                            </div>
                        </div>
                        <div className='ea-custom-form'>
                            <div className='row align-items-end'>
                                <div className='col-md-10'>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <label>Message</label>
                                        <label>Char 32 /50</label>
                                    </div>
                                    <input type='text' className='form-control'/>
                                </div>
                                <div className='col-md-2'>
                                    <label>Exp Date</label>
                                    <input type='text' className='form-control icon-calendar-field pe-5'/>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <AnnouncementsForm/>
                </div>
            </section>
        </Layout>
    </>
  )
}

export default EditAnnouncements